module.exports = __webpack_public_path__ + "media/assets/Help-aa5240dd6ac5821949649f9c064af9d8.svg";